module.exports = __webpack_public_path__ + "assets/f754dda9aa47ffa50fba11cf0a4127e4.png";